import React, { useEffect, useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import { authenticateWithBiometrics, isBiometricAvailable } from '../utils/biometrics';

const RED = '#C62828';
const BG = '#FAF8F4';
const TEXT = '#1A1A1A';
const MUTED = '#757575';
const BORDER = '#EAE4DA';

export default function BiometricLockScreen({ onUnlock }) {
  const [error, setError] = useState(false);

  const tryUnlock = async () => {
    setError(false);
    const success = await authenticateWithBiometrics();
    if (success) onUnlock();
    else setError(true);
  };

  useEffect(() => {
    isBiometricAvailable().then((available) => {
      if (!available) onUnlock();
      else tryUnlock();
    });
  }, []);

  return (
    <View style={styles.container}>
      <StatusBar style="dark" />
      <Text style={styles.title}>Horse Math</Text>
      <Text style={styles.subtitle}>
        {error ? 'Authentication failed. Try again.' : 'Unlock to continue'}
      </Text>
      <TouchableOpacity style={styles.button} onPress={tryUnlock}>
        <Text style={styles.buttonText}>Unlock</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: BG,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 32,
  },
  title: {
    fontSize: 24,
    fontWeight: '700',
    color: TEXT,
    marginBottom: 8,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 15,
    color: MUTED,
    marginBottom: 32,
    textAlign: 'center',
  },
  button: {
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: BORDER,
    borderRadius: 8,
    paddingVertical: 14,
    paddingHorizontal: 32,
    minWidth: 220,
    alignItems: 'center',
  },
  buttonText: {
    fontSize: 16,
    fontWeight: '600',
    color: TEXT,
  },
});
